export default __webpack_public_path__ + "static/media/bg3.bf7bb2ed.jpeg";